<template>
	<div class="wrap">
		<div :style="{
			'background-image': `${bgImage}`,
		}" class="puzzle">
			<div v-for="(day, index) in puzzles" :key="index" class="puzzle_item" :class="{
				done: day.homework && day.homework.complete_status === 2,
				lock: !day.homework,
			}">
				<template v-if="day.homework && day.homework.complete_status === 2"></template>
				<template v-else>
					<p class="order">
						<span>
							{{ day.date.day }}
						</span>
					</p>
					<div class="content">
						<div v-if="!day.homework" class="lock">
							<svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd"
									d="M3.02755 6.92373V5.09416C3.02755 2.28375 5.28316 0 8.07245 0C10.8617 0 13.1174 2.28375 13.1174 5.09416V6.92373H14.5453C15.3569 6.92373 16.002 7.58962 16.002 8.39572V18.528C16.002 19.3341 15.3569 20 14.5453 20H1.45862C0.64699 20 0.00195312 19.3341 0.00195312 18.528V8.39572C0.00195312 7.58962 0.64699 6.92373 1.45862 6.92373H3.02755ZM1.82471 8.7417V18.1816H14.1791V8.7417H1.82471ZM11.2943 6.89589V5.09434C11.2943 3.28205 9.84867 1.81836 8.07222 1.81836C6.29576 1.81836 4.8501 3.28205 4.8501 5.09434V6.89589H11.2943Z"
									fill="#3B3E44" />
							</svg>
						</div>
						<IconLamp class="lamp" v-if="day.homework" />
						<router-link v-if="day && day.homework && !day.homework.matific" :to="{
							name: 'Game Homework',
							query: {
								id: day.homework.id,
								date: day.formattedDate,
								order: day.order,
								read_only: $route.query.read_only,
							},
						}" class="_button">
							<span class="train-text">{{
								getBtnText(day.homework) | translate
							}}</span>
						</router-link>

						<a v-else-if="day && day.homework && day.homework.matific" href="https://www.matific.com/" target="_blank"
							class="matific"><img src="../../../../assets/partners/1.svg" alt="" /></a>
					</div>
				</template>
			</div>
		</div>
		<PuzzleModal v-show="!!modalOpenType" :type="modalOpenType" @close="closeModal" />
	</div>
</template>

<script>
import IconLamp from '../../../svg/IconLamp'
import PuzzleModal from './PuzleModal'

export default {
	components: {
		IconLamp,
		PuzzleModal,
	},
	data: () => ({
		modalOpenType: null,
		bgImage: null,
	}),
	name: 'PuzzleForStudent',
	props: ['puzzles', 'slide'],
	methods: {
		async getPuzzleBg() {
			try {
				const result = await this.axios(
					`storage/files/download_puzzle_image/?slide=${this.slide}`
				)
				if (result.data && result.data.link) {
					this.bgImage = `url(${result.data.link})`
				}
			} catch {
				this.bgImage = require('../../../../assets/puzzle_bg2.jpg')
			}
		},
		getBtnText(homework) {
			return homework.complete_status == 1 ? 'games.resume' : 'Homework '
		},
		closeModal() {
			this.modalOpenType = null
		},
	},
	beforeMount() { },

	mounted() {
		this.getPuzzleBg()
		const success_puzzle_homework_id = JSON.parse(
			window.localStorage.getItem('success_puzzle')
		)

		// console.log(this.puzzles)

		if (success_puzzle_homework_id) {
			if (
				this.puzzles.length ===
				this.puzzles.filter(puzzle => puzzle.homework).length &&
				this.puzzles.every(p => p.homework.complete_status == 2)
			) {
				this.modalOpenType = 'PUZZLE_OPEN'
			} else {
				const puzzle = this.puzzles.find(puzzle => {
					if (
						puzzle &&
						puzzle.homework &&
						puzzle.homework.id === success_puzzle_homework_id
					) {
						return puzzle.homework
					}
				})

				if (puzzle) {
					if (puzzle.homework.complete_status === 2) {
						this.modalOpenType = 'PUZZLE_ITEM_OPEN'
					}
				}
			}
			localStorage.removeItem('success_puzzle')
		}
	},
}
</script>

<style lang="scss" scoped>
@mixin circle($color: #6a5ea4) {
	content: '';
	width: 39px;
	height: 39px;
	border-radius: 10em;
	position: absolute;
	z-index: 1;
	background-color: $color;

	@media (max-width: 1300px) {
		width: 25px;
		height: 25px;
	}

	@media (max-width: 480px) {
		width: 15px;
		height: 15px;
	}
}

.wrap {
	@media (max-width: 1300px) {
		width: 100%;
	}
}

.puzzle {
	background-size: cover;
	background-position: center;
	margin: 5px auto;
	border-radius: 20px;
	overflow: hidden;
	display: grid;
	grid-template-columns: repeat(5, 211px);
	grid-template-rows: repeat(4, 158px);

	@media only screen and (max-width: 1300px) {
		width: 100%;
		grid-template-columns: repeat(5, 1fr);
	}

	@media (max-width: 1300px) {
		grid-template-rows: repeat(4, 100px);
	}

	@media (max-width: 480px) {
		grid-template-rows: repeat(4, 64px);
		width: calc(100% + 20px);
		margin-left: -10px;

		&_item {
			&:nth-child(odd) {

				&:before,
				&:after {
					display: none;
				}
			}

			svg {
				display: none;
			}
		}
	}

	&_item {
		color: #fff;
		position: relative;
		padding: 9px;
		display: flex;
		flex-shrink: 0;

		@media (max-width: 540px) {
			padding: 0px;
		}

		&:nth-child(odd) {
			background-color: #6a5ea4;

			&:before {
				@include circle;
				left: 0;
				top: 50%;
				transform: translate(-50%, -50%);
			}

			&:after {
				@include circle;
				right: 0;
				top: 50%;
				transform: translate(50%, -50%);
			}
		}

		&:nth-child(even) {
			background: #e9407a;

			&:before {
				@include circle(#e9407a);
				top: 0;
				left: 50%;
				transform: translate(-50%, -50%);
			}

			&:after {
				@include circle(#e9407a);
				left: 50%;
				bottom: 0;
				transform: translate(-50%, 50%);
			}
		}

		&.lock {
			cursor: not-allowed;

			@media (max-width: 768px) {
				svg {
					margin-top: 35px;
				}
			}

			svg {
				display: block !important;
				width: 30px;
				height: 30px;

				@media (max-width: 768px) {
					width: 20px;
					height: 20px;
				}

				@media (max-width: 480px) {
					width: 12px;
					height: 12px;
					margin-top: 30px;
				}

				@media (max-width: 380px) {
					margin-top: 20px;
				}

				path {
					fill: #fff;
				}
			}
		}
	}
}

.lamp {
	@media (max-width: 1300px) {
		display: none;
	}
}

.done {
	background-color: transparent !important;

	&:nth-child(odd) {

		&:before,
		&:after {
			background-color: transparent !important;
		}
	}

	&:nth-child(even) {

		&:before,
		&:after {
			background-color: transparent !important;
		}
	}
}

.order {
	position: absolute;
	font-size: 20px;
	padding: 2px;
	left: 4px;
	top: 4px;
	background-color: #e6e9f3;
	height: 40px;
	width: 40px;
	border-radius: 10em;
	font-weight: bold;
	box-shadow: 2px 2px 0 #6a5ea4;

	@media (max-width: 768px) {
		width: 25px;
		height: 25px;
		font-size: 12px;
		transform: translateX(-50%);
		left: 50%;
		top: 25%;
	}

	@media (max-width: 480px) {
		top: 17%;
	}

	@media (max-width: 380px) {
		top: 18%;
		width: 16px;
		height: 16px;
		font-size: 9px;
		padding: 1px;
	}

	span {
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #212529 !important;
		border: 1px dashed #e9407a;
		border-radius: 10em;
		font-weight: bold !important;
	}
}

.content {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding: 20px;

	@media (max-width: 1300px) {
		padding: 10px 0px;
	}

	svg {
		margin-left: auto;
		margin-right: auto;
		flex-shrink: 0;
	}
}

._button {
	color: #fff;
	text-decoration: none;
	background: #e69c50;
	box-shadow: 0 4px 0 #8f4a68;
	border-radius: 30px;
	min-width: 120px;
	padding: 5px 10px;
	height: 32px;
	display: flex;
	margin-top: 20px;
	justify-content: center;
	align-items: center;

	@media (max-width: 1300px) {
		min-width: 100%;
		background-color: transparent;
		box-shadow: none;
		padding: 5px;
		font-size: 14px;
		font-weight: bold;
		margin-top: 35%;
	}

	@media (max-width: 480px) {
		font-size: 10px;
		line-height: 10px;
		margin-top: 45%;
	}

	@media (max-width: 480px) {
		margin-top: 35%;
	}
}

._btn {
	position: absolute;
	background-color: rgba(#fff, 0.3);
	width: 30px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 0;
	border-radius: 3px;

	.fa.fa-trash:before,
	.fa-clone:before {
		color: #fff;
		font-size: 18px;
	}

	&:hover {
		background-color: rgba(#fff, 0.4);
	}

	&-copy {
		right: 50px;
		//transform: translateX(100px);
		top: 10px;
		transition: transform 0.25s ease-in-out;
		transition-delay: 0.25s;
	}

	&-remove {
		right: 10px;
		//transform: translateX(100px);
		top: 10px;
		transition: transform 0.15s ease-in-out;
	}
}
</style>
